<template>
  <div id="loadingTest" v-if="isShowLoading">
      <i></i>
      <span class="loading-txt">{{content}}</span>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isShowLoading: false,
      content:'请等待...'
    }
  }
}
</script>

<style lang="scss" scoped>
  #loadingTest {
    @include fex-absolute-median;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 99999;
    width: 100%;
    height: 100%;
    // background: rgba($color: #ffffff, $alpha: 0.6);
    i {
        display: inline-block;
        width: 0.8rem;
        height: 2rem;
        background: url("../../assets/images/loading_06.svg") center center no-repeat;
    }
}
</style>
